module.exports = __webpack_public_path__ + "img/dishesconfirm2.2b75fa32.png";